module.exports = __webpack_public_path__ + "static/media/married-in-Dubai-2.03c3ef7a.jpg";